import { expect } from 'chai';
export class ConverterTest {
    static runOne(test) {
        if (!test.title) {
            test.title = `Convertion from ${test.encodedValue} to ${test.decodedValue}`;
        }
        if (!test.converter) {
            throw new Error('No converter specified');
        }
        describe(test.title, function () {
            if (!test.skipEncoding) {
                it('encoding', function () {
                    let input = test.decodedValue;
                    if (test.cloneValue) {
                        input = ConverterTest.clone(input);
                    }
                    const result = test.converter ? test.converter.encode(input) : input;
                    if (!test.encodedModifier) {
                        test.encodedModifier = (x) => x;
                    }
                    expect(result).to.be.eql(test.encodedModifier(test.encodedValue));
                });
            }
            if (!test.skipDecoding) {
                it('decoding', function () {
                    if (!test.beforeDecode) {
                        test.beforeDecode = (x) => x;
                    }
                    let input = test.encodedValue;
                    if (test.cloneValue) {
                        input = ConverterTest.clone(input);
                    }
                    const result = test.converter
                        ? test.converter.decode(test.beforeDecode(input))
                        : input;
                    expect(result).to.be.deep.eq(test.decodedValue);
                });
            }
        });
    }
    static runAll(tests, converter) {
        for (const test of tests) {
            if (converter && !test.converter) {
                test.converter = converter;
            }
            ConverterTest.runOne(test);
        }
    }
    static clone(obj) {
        if (Array.isArray(obj) || obj instanceof Uint8Array) {
            return obj.slice(0, obj.length);
        }
        else {
            return Object.assign({}, obj);
        }
    }
}
